import { useMutation, useQuery, useQueryClient } from 'react-query'
import { api } from '../services/api'
import { useState } from 'react'
import { useToast } from '@chakra-ui/react'

async function fetchValidacaoCaricatura({ pedido }) {
  const response = await api.get('/site/v2/fluxo-layout/buscar-ilustracoes-aprovacao', { params: { numero_pedido: pedido } })

  return response.data
}

export const useValidacaoCaricatura = () => {
  const [formValues, setFormValues] = useState({
    pedido: '',
  })

  const queryClient = useQueryClient()

  const query = useQuery({
    queryKey: ['validacao-caricatura', formValues],
    queryFn: () => fetchValidacaoCaricatura(formValues),
    staleTime: 1000 * 60 * 5,
  })

  function onFilter(data) {
    queryClient.invalidateQueries('validacao-caricatura')
    setFormValues(data)
  }

  return { query, setFormValues, onFilter }
}
